/* Diamond Bags theme JS */
(function () {
  'use strict';

  // Header shadow on scroll
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu
  var burger = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('.nav-mobile');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // Rotating announcement
  var ann = document.querySelector('[data-announcements]');
  if (ann) {
    var items = JSON.parse(ann.getAttribute('data-announcements') || '[]');
    var target = ann.querySelector('[data-announcement-text]');
    if (items.length > 1 && target) {
      var i = 0;
      setInterval(function () {
        i = (i + 1) % items.length;
        target.style.opacity = '0';
        setTimeout(function () { target.textContent = items[i]; target.style.opacity = '1'; }, 250);
      }, 4000);
    }
    var close = ann.querySelector('[data-announcement-close]');
    if (close) close.addEventListener('click', function () { ann.style.display = 'none'; });
  }

  // Scroll reveal
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  // Product gallery thumbnails
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) mainImg.src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }
})();
